import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PermGuard({ module, children }) {
  const { can } = useAuth();
  if (!can(module, "view")) return <Navigate to="/dashboard" replace />;
  return children;
}
